module.exports = __webpack_public_path__ + "static/media/car15.9abaa486.jpg";